/**
 * @file Writes the Projects UPDATED cell from a served `updatedAt`: "today",
 * "yesterday" or "N days ago". Consumer: `analyticsUpdatedColumn`. Days are
 * counted as `analyticsDaysPastDue` counts them, local calendar days in the
 * analytics time zone up to the answered period's `to` (the server's own
 * "now"), so the text never depends on the browser's zone or clock.
 */
import { analyticsDaysPastDue } from './analyticsDaysPastDue';

export const analyticsUpdatedText = (
  updatedAt: string,
  to: string,
  timeZone: string,
): string => {
  const days = analyticsDaysPastDue(updatedAt, to, timeZone);
  if (days === 0) return 'today';
  if (days === 1) return 'yesterday';
  return `${days} days ago`;
};
